export default __webpack_public_path__ + "static/media/visa.5411bea1.png";